/*
 * Copyright 2025 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.settings

import androidx.navigation.NavController
import androidx.navigation.NavGraphBuilder
import androidx.navigation.NavOptions
import kotlinx.serialization.Serializable
import studio.oddpods.cauce.core.base.ui.composableWithPushTransitions
import studio.oddpods.cauce.core.base.ui.composableWithStayTransitions

@Serializable
data object SettingsRoute

@Serializable
data object NotificationRoute

@Serializable
data object ReminderSettingsRoute

fun NavController.navigateToSettings(navOptions: NavOptions? = null) =
    navigate(SettingsRoute, navOptions)

fun NavController.navigateToNotification(navOptions: NavOptions? = null) =
    navigate(NotificationRoute, navOptions)

fun NavController.navigateToReminderSettings(navOptions: NavOptions? = null) =
    navigate(ReminderSettingsRoute, navOptions)

fun NavGraphBuilder.settingsTabGraph(
    onNavigateToReminders: () -> Unit = {},
    onNavigateToNotifications: () -> Unit = {},
) {
    composableWithStayTransitions<SettingsRoute> {
        SettingsScreen(
            showNavigationIcon = false,
            onNavigateToReminders = onNavigateToReminders,
            onNavigateToNotifications = onNavigateToNotifications,
        )
    }
}

fun NavGraphBuilder.notificationDestination(
    onBackClick: () -> Unit,
) {
    composableWithPushTransitions<NotificationRoute> {
        NotificationScreen(
            onBackClick = onBackClick,
        )
    }
}

fun NavGraphBuilder.reminderSettingsDestination(
    onBackClick: () -> Unit,
) {
    composableWithPushTransitions<ReminderSettingsRoute> {
        ReminderSettingsScreen(
            onBackClick = onBackClick,
        )
    }
}
